import Canvas from '../canvases/canvas3d';
import AxisRefVisualCartesian from '../axis-ref-visuals/axis-ref-component';
import { componentFactory } from '../lib/lib';
/**
 * canvas factory creates canvas only. for those charts where cartesian axis ref visuals are required
 * @param {Object} chart chart API
 */
export default function (chart) {
  let canvas;
  componentFactory(chart, Canvas, 'canvas', chart.config.showVolumeChart ? 2 : 1);
  canvas = chart.getChildren('canvas');
  if (canvas) {
    for (let i = 0, len = canvas.length; i < len; i++) {
      canvas[i].configure();
      componentFactory(canvas[i], AxisRefVisualCartesian, 'axisRefVisualCartesian');
    }
  }
}
